// extracted by mini-css-extract-plugin
export const logo = "logo-module--logo--2PX9r";